















import { Vue } from "vue-property-decorator";
import Pie from "@/components/PieChart.js";

export default Vue.extend({
  components: {
    Pie
  },
  data() {
    return {
      msg: "🎨 My Interest",
      stats: []
    };
  },
  created() {
    this.stats = this.$store.getters.chartValues;
  }
});
